import {noop} from '@benchling/js-utils';
import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import {Nav, NavItem, Page} from 'bulk-workflows/BulkWorkflowComponents';
import * as BulkTranslationActions from 'bulk-workflows/translation/BulkTranslationActions';
import {BulkTranslation} from 'bulk-workflows/translation/BulkTranslationConstants';
import BulkTranslationEditor from 'bulk-workflows/translation/BulkTranslationEditor';
import BulkTranslationStore from 'bulk-workflows/translation/BulkTranslationStore';
import * as BulkTranslationUtil from 'bulk-workflows/translation/BulkTranslationUtil';
import DataConnector from 'connect/DataConnector';

import * as BulkAntibodyActions from './BulkAntibodyActions';
import * as BulkAntibodyConstants from './BulkAntibodyConstants';
import {BulkAntibody} from './BulkAntibodyConstants';
import BulkAntibodyEditor from './BulkAntibodyEditor';
import BulkAntibodyStore from './BulkAntibodyStore';

class BulkAntibodyPageConnector extends DataConnector<Props, EnhancedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [BulkAntibodyStore, BulkTranslationStore];

  enhanceProps(): EnhancedProps {
    return {
      bulkTranslation: this.bulkTranslationStore().getBulkTranslation(),
      bulkAntibody: this.bulkAntibodyStore().getBulkAntibody(),
    };
  }
}

interface Props {}
interface EnhancedProps {
  bulkAntibody: BulkAntibody;
  bulkTranslation: BulkTranslation;
}

class BulkAntibodyPage extends React.Component<Props & EnhancedProps> {
  override componentDidMount(): void {
    BulkTranslationActions.reset();
    BulkAntibodyActions.reset();
  }

  _renderEditor = (): JSX.Element => {
    const {bulkAntibody, bulkTranslation} = this.props;
    if (bulkAntibody.step === BulkAntibodyConstants.Step.BULK_TRANSLATION) {
      return <BulkTranslationEditor bulkTranslation={bulkTranslation} />;
    }
    assert(
      bulkAntibody.step === BulkAntibodyConstants.Step.BULK_ANTIBODY,
      `Expected to render \`STEP.BULK_ANTIBODY\`, not ${bulkAntibody.step}`
    );
    return <BulkAntibodyEditor bulkAntibody={bulkAntibody} />;
  };

  override render = (): JSX.Element => {
    const {bulkAntibody, bulkTranslation} = this.props;
    return (
      <Page>
        <Nav header="Bulk Translate DNA to AA and Create Antibodies">
          <NavItem
            isActive={bulkAntibody.step === BulkAntibodyConstants.Step.BULK_TRANSLATION}
            onClick={noop}
            hasErrors={!_.isEmpty(BulkTranslationUtil.getErrors(bulkTranslation))}
          >
            Translate DNA
          </NavItem>
          <NavItem isActive={bulkAntibody.step === BulkAntibodyConstants.Step.BULK_ANTIBODY} onClick={noop}>
            Create Antibodies
          </NavItem>
        </Nav>
        {this._renderEditor()}
      </Page>
    );
  };
}

export default BulkAntibodyPageConnector.connect(BulkAntibodyPage);
